'use client';
import { JSX } from 'react';

// components
import { OrPromotionalBlock } from './or-promotional-block';

// types
import {
  EBlockAlignment,
  EThemes,
} from '@/lib/contentstack-sdk/types/component';

// hooks
import { usePromos } from '@/hooks/usePromos';

// utils
import { parsePromos } from '@/lib/contentstack-sdk/utils/parseHelpers';
import { useLocation } from '@/context/locationContext';
import { IOrPromotionalBlockPropsCS } from './or-promotional-block.types';
import { AtText } from '@/components/atoms/at-text/at-text';

export const OrPromotionalBlockCS = ({
  block,
}: IOrPromotionalBlockPropsCS): JSX.Element => {
  const { getPromosByLocation, loading, error } = usePromos();
  const { currentBuildStudio } = useLocation();

  const promos = getPromosByLocation(currentBuildStudio?.Id, true);

  if (loading) return <p>Loading promotions...</p>;
  if (error) return <p>{error}</p>;

  const {
    autoplay,
    promo_block_copy,
    theme: { theme },
    top_spacing,
    bottom_spacing,
  } = block;

  if (promo_block_copy.length <= 0) {
    return (
      <AtText className="text-skin-error">
        Please add an instance of Copy Block
      </AtText>
    );
  }

  const { alignment, title, block_header, description, link } =
    promo_block_copy[0];

  return (
    <OrPromotionalBlock
      autoplay={autoplay}
      blockAlignment={
        EBlockAlignment[alignment.alignmentprop as keyof typeof EBlockAlignment]
      }
      topSpacing={top_spacing?.spacing_value}
      bottomSpacing={bottom_spacing?.spacing_value}
      topDivider={top_spacing?.divider}
      bottomDivider={bottom_spacing?.divider}
      cta={link}
      description={description}
      header={block_header}
      title={title}
      promos={parsePromos({ promos, isPromoBlock: true })}
      theme={EThemes[theme]}
    />
  );
};
